/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.vue?vue&type=style&index=0&id=441da3d7&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=441da3d7&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.108.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441da3d7"]])

export default __exports__